import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-950 py-12" data-id="element-46" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-47" data-mp="3ggaq1tbg494e">
        <p className="font-display text-lg uppercase text-white" data-id="element-48" data-mp="32nummremu92y">48 Hrs AI Cash Machine</p>
        <p className="mt-1 text-xs uppercase tracking-[0.3em] text-white/40" data-id="element-49" data-mp="32m1et8sa9itd">Gabriel Beltran</p>
        <p className="mx-auto mt-6 max-w-xl text-xs leading-relaxed text-white/35" data-id="element-50" data-mp="36n3c3k2n3ksp">
          Este sitio no forma parte de Facebook ni de Meta Platforms, Inc. Los resultados
          mostrados no representan una garantía de ingresos: dependen de tu ejecución, tu mercado
          y tu esfuerzo.
        </p>
        <nav aria-label="Enlaces legales" className="mt-6" data-id="element-51" data-mp="3qdf2h1fhoq80">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/45" data-id="element-52" data-mp="3qbvnrf9hen8c">
            <li data-id="element-53" data-mp="29xvqkc20tbos">
              <a href="#comprar" className="hover:text-white" data-id="element-54" data-mp="2a1jkhcbdo041">
                Términos y condiciones
              </a>
            </li>
            <li data-id="element-55" data-mp="3l8qvw2zluhqx">
              <a href="#comprar" className="hover:text-white" data-id="element-56" data-mp="3labovo69tsmo">
                Política de privacidad
              </a>
            </li>
            <li data-id="element-57" data-mp="3gcjw6rxsy2hf">
              <a href="#comprar" className="hover:text-white" data-id="element-58" data-mp="3v7q2zh4q25bt">
                Soporte
              </a>
            </li>
          </ul>
        </nav>
        <p className="mt-6 text-xs text-white/25" data-id="element-59" data-mp="3q7u39u325022">
          © {new Date().getFullYear()} 48 Hrs AI Cash Machine. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}